import { Tooltip, Typography } from '@mui/material'
import React, { HTMLAttributes } from 'react'

import { type TestSuiteScenarioOption } from 'components/test-suites/forms/test-suite-composition/test-suite-composition-utils'
import { TestSuiteScenarioInfo } from 'components/test-suites/forms/test-suite-composition/TestSuiteScenarioInfo'

export const TestSuiteScenarioSearchOption = React.forwardRef<
  HTMLLIElement,
  {
    option: TestSuiteScenarioOption
    props: HTMLAttributes<HTMLLIElement>
  }
>(({ option, props, ...rest }, ref) => {
  const label = option.label ?? '""'

  return (
    <li {...props} {...rest} key={option.guid} ref={ref}>
      <Tooltip
        title={
          <TestSuiteScenarioInfo
            id={option.guid}
            owningTeamLabel={option.owningTeamLabel ?? undefined}
          />
        }
      >
        <Typography>{label}</Typography>
      </Tooltip>
    </li>
  )
})
